import { ComponentChildren } from 'preact';
import { cssProps } from '@oracle/oraclejet-cssprops';

const hiddenAccessibleStyle = cssProps`${{
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflowX: 'hidden',
  overflowY: 'hidden',
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  width: '1px',
  position: 'absolute'
}}`;

type HiddenAccessibleProps = {
  /**
   * Specifies the ComponentChildren
   */
  children?: ComponentChildren;

  /**
   * HTML id for the rendered element
   */
  id?: string;

  /**
   * Specifies whether the element is hidden to the screen readers by default.
   * However, one can override it using aria-describedby/aria-labelledby. This is
   * useful when the content should be read only as a description for another content
   * and not as a content of the container.
   */
  isHidden?: boolean;
};

/**
 * HiddenAccessible is a helper component that hides its children visually,
 * but keeps them visible to screen readers.
 *
 */
function HiddenAccessible({ children, id, isHidden }: HiddenAccessibleProps) {
  return (
    <span id={id} class={hiddenAccessibleStyle} hidden={isHidden}>
      {children}
    </span>
  );
}

export { HiddenAccessible };
